import { TypographyProps } from '@mui/material';
import Typography from '@mui/material/Typography';
import { CmsEditableFormHeadingData } from '@/services/cms/userDefinedForm/CmsEditableFormHeadingData';

export type EditableFormHeadingProps = CmsEditableFormHeadingData;

export const EditableFormHeading = (props: EditableFormHeadingProps) => <Typography variant={`h${props.level || 5}` as TypographyProps['variant']}>{props.title}</Typography>;
